/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramHomepageShortcutsControllerFindManyQueryResponse } from '../types/TelegramHomepageShortcutsControllerFindMany.ts';

function getTelegramHomepageShortcutsFindManyUrl() {
  const res = { method: 'GET', url: `/api/telegram/homepage-shortcuts` as const };
  return res;
}

/**
 * {@link /api/telegram/homepage-shortcuts}
 */
export async function telegramHomepageShortcutsFindMany(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramHomepageShortcutsControllerFindManyQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramHomepageShortcutsFindManyUrl().url.toString(), ...requestConfig });
  return res.data;
}
